export default __webpack_public_path__ + "media/zurb/img/contact/contact-chris-2a2b816c70cb780825d50c1991d6a8ed.png";